import { SignupSteps } from 'routes/Signup/constants/SignupSteps'

export const PaymentMethod = {
  Card: 'Card',
  PayPal: 'PayPal',
  ApplePay: 'ApplePay',
  Bento: 'Bento',
}

const checkAccountPageSlug = 'start'
const applyVoucherPageSlug = 'apply-voucher'
const enterPromoCodeManuallyPageSlug = 'enter-discount-code'
const postcodeSlug = 'postcode'
const boxPriceSlug = 'box-size'

export const signupConfig = {
  /**
   * If experiment steps should be added:
   * 1. Create another entry in signupConfig with listing appropriate steps (similar to signupConfig.defaultSteps).
   * 2. Add entries of new steps into signupConfig.steps array.
   * 3. Refer to new steps variable in "getSignupSteps.ts" file.
   * 4. Map step to component in "AvailableStepComponents.ts" file.
   */
  defaultSteps: [SignupSteps.BOX_SIZE, SignupSteps.POSTCODE, SignupSteps.DELIVERY],
  steps: [
    { name: SignupSteps.BOX_SIZE, slug: 'box-size' },
    { name: SignupSteps.POSTCODE, slug: 'postcode' },
    { name: SignupSteps.DELIVERY, slug: 'delivery-options' },
  ],
  menuPersonalisationSteps: [
    { name: SignupSteps.BOX_SIZE, slug: 'box-size' },
    { name: SignupSteps.POSTCODE, slug: 'postcode' },
    { name: SignupSteps.DELIVERY, slug: 'delivery-options' },
    { name: SignupSteps.DIETARY_PREFERENCES, slug: 'dietary-preferences' },
    { name: SignupSteps.RECIPE_PREFERENCES, slug: 'recipe-preferences' },
  ],
  payment_types: {
    card: 'card',
    paypal: 'paypal',
  },
  address_types: {
    billing: 'billing',
    shipping: 'shipping',
  },
  boxSizeStep: {
    title: 'Choose your box size',
    discountApplied: 'Discount applied',
  },
  postCodeStep: {
    title: 'Where would you like your boxes delivered?',
    goustoOnDemandTitle: 'Where would you like your box delivered?',
    reminder: 'Delivered to your door, 7 days a week*',
    doNotDeliverErrorMessage: 'Sorry, it looks like we don’t currently deliver to your area.',
    genericErrorMessage: 'Please enter a valid postcode',
    footNoteMessage: '*Your available delivery days depend on your area',
  },
  deliveryOptionsStep: {
    title: 'When would you like your first delivery?',
    goustoOnDemandTitle: 'When do you want your box delivered?',
  },
  dietaryPreferencesStep: {
    title: 'Any dietary preferences?',
    description:
      'Let us know about any dietary preferences in your household and we’ll show you more suitable recipes first.',
    notice: 'Don’t worry you’ll still get to see our full menu!',
    selectAllOptionsLabel: 'We can eat everything',
    dietaryPreferencesLabel: 'We have dietary preferences',
    dietaryPreferencesOptions: {
      vegetarian: 'Vegetarian',
      plantBased: 'Plant-Based',
      pescatarian: 'Pescatarian',
      dairyFree: 'Dairy-Free',
      glutenFree: 'Gluten-Free',
      noSeafood: 'No Seafood',
    },
  },
  recipePreferencesStep: {
    title: 'What types of recipes do you like?',
    descriptionBoldText: 'Choose 3 or more recipes',
    descriptionRegularText: 'you like the look of and we will show recipes we think you’ll love',
    notice: 'Don’t worry you’ll still get to see our full menu!',
    seeMenuCTA: 'See your menu',
  },
  continueCTA: 'Continue',
  skipCTA: 'Skip',
  discountAppliedText: 'View this when you reach the checkout.',
  sellThePropositionPageSlug: 'about',
  checkAccountPageSlug,
  applyVoucherPageSlug,
  enterPromoCodeManuallyPageSlug,
  canLandOnStepWithoutRedirecting: [
    checkAccountPageSlug,
    applyVoucherPageSlug,
    enterPromoCodeManuallyPageSlug,
    /**
     * Required for redirected to postcode from box prices.
     */
    postcodeSlug,
    boxPriceSlug,
  ],
}
